// have to simulate click because Safari Mobile

import { getElementArrayByAttribute } from './getElementArrayByAttribute';
import { simulateClick } from './simulateClick';

export const clearCart = () => {
  const setClearCart = setInterval(async () => {
    try {
      const buttons = getElementArrayByAttribute('[data-fp="clear-cart"]');

      if (buttons) {
        clearInterval(setClearCart);

        const clearCart = () => {
          const removeButtons = getElementArrayByAttribute(
            '[data-wf-cart-action="remove-item"]'
          );

          for (let i = 0; i < removeButtons.length; i++) {
            simulateClick(removeButtons[i]);
          }
        };

        buttons.forEach((button) => {
          button.addEventListener('click', clearCart);
        });
      }
    } catch (error) {
      clearInterval(setClearCart);
      throw error;
    }
  }, 50);
};
